import Avatar from '../Avatar/index.vue';
import AppVersion from '@/components/AppVersion';
import UsersService from '@/services/users.service';
import { Capacitor } from '@capacitor/core';

export default {
    name: 'MenuMobile',

    components: {
        AppVersion,
        Avatar
    },

    data() {
        return {
            image: null,
            isMobile: window.innerWidth <= 991
        };
    },

    props: ['sections'],

    methods: {
        hideMenuMobile() {
            this.$root.$emit('hideMenuMobile', false);
        },

        logout() {
            // Vamos a guardar temporalmente el valor del acceso biometrico habilitado
            // para guardarlo después de borrar toda la local storage, ya que lo
            // necesitamos para el login
            const biometricAccess = localStorage.getItem('biometricAccess');
            const dismissBiometricAccessTimestamp = localStorage.getItem(
                'dismissBiometricAccessTimestamp'
            );

            localStorage.clear();
            this.$store.dispatch('setDefaultStore');
            if (biometricAccess) {
                localStorage.setItem('biometricAccess', true);
            }
            if (dismissBiometricAccessTimestamp) {
                localStorage.setItem(
                    'dismissBiometricAccessTimestamp',
                    dismissBiometricAccessTimestamp
                );
            }
            this.$root.$emit('refreshLayout');

            if (localStorage.getItem('ADMIN')) {
                this.$router.push({ name: 'login' });
            } else {
                this.$router.push({ name: 'login', params: { advice: true } });
            }
        },
        showVideoAction() {
            this.$root.$emit('showVideoAction');
        },

        async goToTaxDown() {
            try {
                this.$store.dispatch('showLoading');
                const getTaxDownUrlRes = await UsersService.getTaxDownUrl();
                this.$store.dispatch('hideLoading');
                const taxDownUrl = getTaxDownUrlRes.data.tax_down_url;

                if (Capacitor.isNativePlatform()) {
                    let inAppBrowserOptions = 'location=no, beforeload=yes';
                    if (Capacitor.getPlatform() === 'android') {
                        inAppBrowserOptions += ',zoom=no';
                    }
                    window.cordova.InAppBrowser.open(
                        encodeURI(taxDownUrl),
                        '_blank',
                        inAppBrowserOptions
                    );
                } else {
                    const newTab = window.open(taxDownUrl, '_blank');
                    if (newTab) {
                        newTab.focus();
                    } else {
                        console.warn('El navegador bloqueó la apertura de la nueva ventana');
                    }
                }
            } catch (error) {
                console.error(error);
                this.$bvToast.toast(`${error.message}`, {
                    title: 'Error',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 10000,
                    variant: 'danger'
                });
            } finally {
                this.$store.dispatch('hideLoading');
            }
        },

        goToCiberSecurity() {
            this.$router.push({ name: 'cibersecurity' });
        },

        goToCobasPlus() {
            let cobasPlusUrl = this.$store.getters.redirectToCobasPlus;

            if (Capacitor.isNativePlatform()) {
                let inAppBrowserOptions = 'location=no, beforeload=yes';
                if (Capacitor.getPlatform() === 'android') {
                    inAppBrowserOptions += ',zoom=no';
                }

                this.ref = window.cordova.InAppBrowser.open(
                    encodeURI(cobasPlusUrl),
                    '_blank',
                    inAppBrowserOptions
                );
            } else {
                const newTab = window.open(cobasPlusUrl, '_blank');
                if (newTab) {
                    newTab.focus();
                } else {
                    console.warn('El navegador bloqueó la apertura de la nueva ventana');
                }
            }
        },
        GoToGetCobasPlus() {
            this.$router.push({ name: 'GetCobasPlus' });
        }
    },

    computed: {
        currentUser() {
            const lastname_1 = this.intervener.lastname_1 ? this.intervener.lastname_1 : '';
            const lastname_2 = this.intervener.lastname_2 ? this.intervener.lastname_2 : '';

            return `${this.intervener.name} ${lastname_1} ${lastname_2}`;
        },

        getUserInitials() {
            const abbr = `${this.intervener.name.substring(
                0,
                1
            )}${this.intervener.lastname_1.substring(0, 1)}`;

            return abbr;
        },

        intervener() {
            return UsersService.getIntervenerFromLocalStore();
        }
    }
};
